import React, { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';

import {
  IconButton,
  Dialog,
  AppBar,
  Toolbar,
  DialogContent,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import { t } from '~/helpers';

export default function HelpButton(path) {
  const [openDialog, setOpenDialog] = useState(false);
  const { navigations } = useSelector((state) => state.drawer);

  const {
    tokenvideoconfigsistema,
    urlplataformavideoconfigsistema,
  } = JSON.parse(sessionStorage.getItem('web'));

  const menuRoute = path.pathname.split('/')[1];

  const checkHelpButtonOnRoute = () => {
    let routeFinded;
    navigations.forEach((routes) =>
      routes.submenus.filter((route) => {
        if (route.submenus.length > 0) {
          route.submenus.filter((subroute) => {
            if (subroute.rotamenu === path.pathname) {
              routeFinded = subroute;
            }
          });
        } else if (route.rotamenu === path.pathname) {
          routeFinded = route;
        }
      })
    );
    return routeFinded?.helpmenu === 'N';
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => setOpenDialog(true)}
        disabled={
          checkHelpButtonOnRoute() || urlplataformavideoconfigsistema === null
        }
      >
        <HelpOutlineIcon />
      </IconButton>
      <Dialog fullScreen open={openDialog}>
        <AppBar style={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setOpenDialog((prevState) => !prevState)}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography variant="h6">{t('s.menu.videohelp')}</Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <iframe
            src={`${urlplataformavideoconfigsistema}?token=${tokenvideoconfigsistema}&search=${menuRoute}`}
            height="100%"
            width="100%"
            frameBorder="0"
            allowFullScreen
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
